import { useThunkDispatch } from '~/utils/hooks/useThunkDispatch';
import { useSelector } from 'react-redux';
import { getUserProfileData } from '~/features/dashboard/store/selectors';
import { useCallback, useEffect, useMemo } from 'react';
import { getUserProfile } from '~/features/dashboard/store/actions.thunks';
import { UserProfile } from '~/models/profile/UserProfile.dto';

type KeyType = keyof UserProfile;

export function useProfile(key?: KeyType) {
    const dispatch = useThunkDispatch();

    const userProfileResponse = useSelector(getUserProfileData);
    useEffect(() => {
        !userProfileResponse && dispatch(getUserProfile());
    }, [userProfileResponse, dispatch]);

    const value = useMemo(() => userProfileResponse && key ? userProfileResponse[key] : undefined, [userProfileResponse, key]);
    const getter = useCallback((property?: KeyType) => userProfileResponse && property ? userProfileResponse[property] : undefined, [userProfileResponse]);

    return [value, getter];
}
